
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {
    useGetReferral, ReferralRewardUpdate, useGetCashbackBalance,
    useUpdateReferralLink
} from '../api/apiReferral';
import { useCheckAdminAccess } from '../../WhiteIp/api/whiteipapi';
import { logout } from '../../../hooks/logout';
import PermissionDenied from '../../common/permissionDenied';
import { WaitingLoader } from '../../../hooks/buttonLoad';
import { CircularProgress } from "@mui/material";
import ReferralFeeManage from './ReferralFeeManage';
import '../tabs/button.css'
import { useToast } from '../../../hooks/usetoast';



const schema = yup.object().shape({
    bonus: yup
        .number()
        .transform((value, originalValue) => (originalValue === '' ? null : value))
        .required('Referral Sign-up and Top-up Bonus is required')
        .moreThan(0, 'Minimum amount must be greater than 0')
        .max(1000, 'Referral Sign-up and Top-up Bonus must not exceed 1000'),
    maxEligibleAmnt2: yup
        .number()
        .transform((value, originalValue) => (originalValue === '' ? null : value))
        .required('Maximum Eligible Amount is required')
        .moreThan(0, 'Maximum Eligible Amount must be greater than 0')
        .max(1000, 'Maximum Eligible Amount must not exceed 1000'),

    maxEligibleAmnt: yup
        .number()
        .transform((value, originalValue) => (originalValue === '' ? null : value))
        .required('Maximum Eligible Amount is required')
        .moreThan(0, 'Maximum Eligible Amount must be greater than 0')
        .max(1000, 'Maximum Eligible Amount must not exceed 1000'),

});

function Referralreward() {

    const toast = useToast()

    const { data: Referral, isLoading, isError, error } = useGetReferral();
    const { data: getReferralBalance, isLoading: refLoading } = useGetCashbackBalance();
    const updateReward = ReferralRewardUpdate();
    const referralLinkMutation = useUpdateReferralLink()


    const { control, handleSubmit, formState: { errors, isValid, isDirty }, setValue } = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: {
            ReferralReward: 0,
            Allowance: 0,
            maxEligibleAmnt: 0,
            maxEligibleAmnt2: 0
        },
    });



    useEffect(() => {
        setValuesFromAPI();
    }, [Referral, setValue]);

    const setValuesFromAPI = () => {
        if (Referral?.data?.getRefData) {
            setValue('bonus', Number(Referral?.data?.getRefData?.rWdSwTbH) || 0);
            setValue('maxEligibleAmnt', Number(Referral?.data?.getRefData?.maxEligibleAmnt) || 0);
            setValue('maxEligibleAmnt2', Number(Referral?.data?.getRefData?.acdEnautga) || 0);

        }
    };





    const onSubmit = async (data) => {

        if (!Referral?.data?.getRefData?._id) {
            return;
        }

        const payload = {
            _id: Referral?.data?.getRefData?._id,
            rWdSwTbH: Number(data?.bonus),
            maxEligibleAmnt: Number(data?.maxEligibleAmnt),
            acdEnautga: Number(data?.maxEligibleAmnt2),

        };

        try {
            const res = await updateReward.mutateAsync(payload);
            return res
        } catch (err) {
        }
    };



    const checkAdminMutation = useCheckAdminAccess();
    const [access, setAccess] = useState(true);

    useEffect(() => {
        checkAdminAccess();

    }, []);

    const checkAdminAccess = async () => {
        try {
            const obj = { page: 'Referral Management' };
            const checkAdminRes = await checkAdminMutation.mutateAsync(obj);
            if (!checkAdminRes?.data?.status) {
                setAccess(false);
                logout();
            } else {
                setAccess(true);
            }
        } catch (error) {
            setAccess(false);
        }
    };

    let updateReferralLinkStatus = async (status) => {
        try {
            if (status == Referral?.data?.getRefData?.isRePmCvReWdf) {
                return
            }
            const response = await referralLinkMutation.mutateAsync({

                isRePmCvReWdf: status
            });
            if (!response?.data?.status) {
                return toast.error(response?.data?.message)
            }
            toast.success(response?.data?.message)
        } catch (error) {

        }
    }



    let content;
    if (refLoading) {
        content = <WaitingLoader />;
    } else if (access) {
        content = (
            <>
                {
                    referralLinkMutation.isLoading && <WaitingLoader />
                }
                <div className="ad_pg_bx bg-white px-4 py-3 row" style={{ minWidth: "40vw" }}>


                    <div className=' my-4'>
                        <div className="text-center">
                            <h5>Referral Link Generation:</h5>
                        </div>

                        <div className="d-flex justify-content-center align-items-center mt-4">

                            <div className="mx-3">
                                <label htmlFor="filter" className="switch" aria-label="Toggle Filter">
                                    <input
                                        type="checkbox"
                                        id="filter"
                                        checked={!Referral?.data?.getRefData?.isRePmCvReWdf}
                                    />
                                    <span
                                        role="button"
                                        tabIndex={0}
                                        onClick={() => updateReferralLinkStatus(true)}

                                        className="your-custom-span-style"
                                    >
                                        Topup
                                    </span>
                                    <span
                                        role="button"
                                        tabIndex={0}
                                        onClick={() => updateReferralLinkStatus(false)}

                                        className="your-custom-span-style"
                                    >
                                        Card Creation
                                    </span>
                                </label>
                            </div>

                        </div>
                    </div>

                </div>

                <div className="ad_pg_bx bg-white px-4 py-3 row" style={{ minWidth: "40vw", marginTop: "15px" }}>
                    <div className='row g-3 pb-3'>

                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 ">
                            <div className="ad_pg_cd_cnt">
                                <button
                                    className="ad_pg_cd_cnt w-100 bg-transparent border-0 p-0"
                                    onClick={() => {
                                        const url = getReferralBalance?.data?.data?.data?.addressUrl;
                                        if (url) {
                                            window.open(url, '_blank');
                                        }
                                    }}
                                >
                                    <div className="ad_pg_cd" style={{ backgroundColor: "#4F5CFB" }}>
                                        <div className="ad_pg_cd_rcnt tp">
                                            <div className="col-auto ad_pg_cd_c">
                                                <div className="ad_pg_cd_lb">Polygon Balance</div>
                                                <div className="ad_pg_cd_vl">
                                                    {parseFloat(getReferralBalance?.data?.data?.data?.coin).toFixed(6)} POL
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </button>

                            </div>

                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 ">
                            <div className="ad_pg_cd_cnt">

                                <button
                                    className="ad_pg_cd_cnt w-100 bg-transparent border-0 p-0"
                                    onClick={() => {
                                        const url = getReferralBalance?.data?.data?.data?.referralBalUrl;
                                        if (url) {
                                            window.open(url, '_blank');
                                        }
                                    }}
                                >
                                    <div className="ad_pg_cd" style={{ backgroundColor: "#4F5CFB" }}>
                                        <div className="ad_pg_cd_rcnt tp">
                                            <div className="col-auto ad_pg_cd_c">
                                                <div className="ad_pg_cd_lb">Referral Address Balance</div>
                                                <div className="ad_pg_cd_vl">
                                                    {getReferralBalance?.data?.data?.data?.referral} ROU
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </button>

                            </div>

                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 ">
                            <div className="ad_pg_cd_cnt">
                                <button
                                    className="ad_pg_cd_cnt w-100 bg-transparent border-0 p-0"
                                    onClick={() => {
                                        const url = getReferralBalance?.data?.data?.data?.cashBackUrl;
                                        if (url) {
                                            window.open(url, '_blank');
                                        }
                                    }}
                                >
                                    <div className="ad_pg_cd" style={{ backgroundColor: "#4F5CFB" }}>
                                        <div className="ad_pg_cd_rcnt tp">
                                            <div className="col-auto ad_pg_cd_c">
                                                <div className="ad_pg_cd_lb">Cashback Contract Balance</div>
                                                <div className="ad_pg_cd_vl">
                                                    {getReferralBalance?.data?.data?.data?.cashback} ROU
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </button>

                            </div>
                        </div>

                    </div>

                </div>


                <div className="ad_pg_bx bg-white px-4 py-3 row" style={{ minWidth: "40vw", marginTop: "15px" }}>
                    <h2>Referral Reward</h2>
                    {isLoading && <CircularProgress />}
                    {isError && (
                        <p className="errMsg">
                            Error loading data: {error?.message || "Unknown error"}
                        </p>
                    )}

                    {!isLoading && !isError && (
                        <form onSubmit={handleSubmit(onSubmit)} noValidate>
                            <div className="row px-5">

                                <div className="col mt-4"> <h6><span>1</span> <span className=' ms-2'>Create Card and Top-up Bonus Rewards (in $) </span></h6></div>
                                <div className="col">
                                    <div className="col-9 ">

                                        <div className="input-group mt-3 ms-3">

                                            <Controller
                                                name="bonus"
                                                control={control}

                                                render={({ field }) => (
                                                    <input
                                                        {...field}
                                                        type="number"
                                                        className="form-control"
                                                        placeholder="Enter Referral Reward"
                                                        min="1"
                                                        max="100"

                                                    />

                                                )}
                                            />
                                        </div>
                                        {errors.bonus && (
                                            <p className="errMsg">{errors.bonus.message}</p>
                                        )}
                                    </div>
                                </div>

                            </div>
                            <div className="row px-5">
                                <div className="col mt-4">
                                    <h6> <span>2</span > <span className=' ms-2'>Top-Up Amount Eligible for Reward (in $)</span></h6>

                                </div>
                                <div className="col">
                                    <div className="col-9 ">
                                        <div className="input-group mt-3 ms-3">
                                            <Controller
                                                name="maxEligibleAmnt"
                                                control={control}
                                                render={({ field }) => (
                                                    <input
                                                        {...field}
                                                        type="number"
                                                        className="form-control"
                                                        placeholder="Enter Amount"
                                                        min="1"
                                                        max="100"
                                                    />
                                                )}
                                            />
                                        </div>
                                        {errors.maxEligibleAmnt && (
                                            <p className="errMsg">{errors?.maxEligibleAmnt?.message}</p>
                                        )}
                                    </div>
                                </div>

                            </div>
                            {
                                !Referral?.data?.getRefData?.isRePmCvReWdf &&
                                <div className="row px-5">
                                    <div className="col mt-4">
                                        <h6><span>3</span ><span className=' ms-2'> Minimum Top - Up Amount to Generate Referral Link (in $)</span></h6>
                                    </div>
                                    <div className="col">
                                        <div className="col-9 ">
                                            <div className="input-group mt-3 ms-3">
                                                <Controller
                                                    name="maxEligibleAmnt2"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <input
                                                            {...field}
                                                            type="number"
                                                            className="form-control"
                                                            placeholder="Enter Amount"
                                                            min="1"
                                                            max="100"
                                                        />
                                                    )}
                                                />
                                            </div>
                                            {errors.maxEligibleAmnt2 && (
                                                <p className="errMsg">{errors?.maxEligibleAmnt2?.message}</p>
                                            )}
                                        </div>
                                    </div>

                                </div>
                            }

                            <div className=" d-flex justify-content-center mt-5" >
                                <button
                                    type="submit"
                                    className="btn btn-primary d-flex align-items-center px-4"
                                    disabled={updateReward.isLoading || !isValid || !isDirty}
                                >
                                    {updateReward.isLoading ? (
                                        <CircularProgress size={20} sx={{ color: "#fff", mx: 2 }} />
                                    ) : (
                                        "Submit"
                                    )}
                                </button>
                            </div>
                        </form>
                    )}
                </div>
                <div className=' mt-5'>
                    <ReferralFeeManage />
                </div>
            </>

        );
    } else {
        content = <PermissionDenied />;
    }

    return <>{content}</>;


}

export default Referralreward;